import { CircularProgress, Grid } from '@material-ui/core';
import { jsPDF } from "jspdf";
import React, { useState } from 'react';
import '../../../scss/UVP.scss';
import { TokensVService, TokenType } from '../../../services/V3/gozer';
import { dateToLocal, formatMoney, handleErrorToast } from '../../shared/Functions';

export const PaymentFlowPage3 = ({
    successToast,
    errorToast,
    district,
    billingAccount,
    tokens,
    paymentToken,
    cancel,
    amount,
    fee,
    newEmail,
    newPayment,
    paymentMade,
}) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [pdfDoc, setPdfDoc] = useState<any>();
    const [pdfDocSuccess, setPdfDocSuccess] = useState<boolean>(false);

    const createPdf = async () => {
        const pdf = new jsPDF("portrait", "pt", "letter");
        const data = document.querySelector("#pdf")?.innerHTML ?? new HTMLElement();
        pdf.html(data, {
            width: 1000,
            windowWidth: 1000
        })
        setPdfDoc(pdf)
        setPdfDocSuccess(true)
    }

    const savePdf = (pdfDoc) => {
        pdfDoc.save("PaymentTransactionReceipt.pdf");
    }

    const tokenExists = (tokenId) => {
        return tokens.filter(x => x.id === tokenId).length === 1;
    }

    const saveMethod = (needsSaved) => {
        setLoading(true)
        if ((newPayment?.ach || newPayment?.terminal || newPayment?.cc) && paymentMade?.token?.id) {
            TokensVService.tokensVUpdateToken(billingAccount.id, paymentMade?.token?.id ?? paymentToken?.id, {
                saveToWallet: needsSaved
            })
                .then(t => {
                    if (needsSaved) {
                        successToast("Successfully added payment method to account")
                    }
                    else {
                        successToast("Payment method not added to account")
                    }
                    setLoading(false)
                })
                .catch(err => {
                    errorToast(handleErrorToast(err))
                    setLoading(false)
                });
        }
    }

    return (
        <React.Fragment>
            {paymentMade &&
                <>
                    <div hidden id="pdf">
                        <div className='uvp-receipt'>
                            <div><h6><b>Payment Receipt for {district.name}</b></h6></div>
                            <p>Thank you for your payment!</p>
                            <div className='uvp-receipt-item'>
                                <div><b>Payment Date:</b></div>&nbsp;
                                <div>{paymentMade?.createdAt ? dateToLocal(paymentMade.createdAt).toLocaleDateString() : (new Date()).toLocaleDateString()}</div>
                            </div>
                            <div className='uvp-receipt-item'>
                                <div><b>Account Number:</b></div>&nbsp;
                                <div>{billingAccount?.accountNumber}</div>
                            </div>
                            <div className='uvp-receipt-item'>
                                <div><b>Account Name:</b></div>&nbsp;
                                <div>{billingAccount?.customer?.fullName}</div>
                            </div>
                            <div className='uvp-receipt-item'>
                                <div><b>Payment Method:</b></div>&nbsp;
                                <div>{paymentMade?.token ?
                                    `${paymentMade?.token?.tokenType === TokenType.CC ? paymentMade?.token?.cardType :
                                        `${paymentMade?.token?.achAccountHolderType} ${paymentMade?.token?.achType}`} ****${paymentMade?.token?.last4}` :
                                    paymentToken && paymentToken?.id !== "CCTerminal" ? `${paymentToken.tokenType === TokenType.CC ?
                                        paymentToken?.cardType : `${paymentToken?.achAccountHolderType} ${paymentToken?.achType}`} ****${paymentToken?.last4}` : "Terminal"}</div>
                            </div>
                            <div className='uvp-receipt-item'>
                                <div><b>Payment Amount:</b></div>&nbsp;
                                <div>{formatMoney(amount)}</div>
                            </div>
                            <div className='uvp-receipt-item'>
                                <div><b>Service Fee:</b></div>&nbsp;
                                <div>{formatMoney(paymentMade?.serviceFeeAmount)}</div>
                            </div>
                            <div className='uvp-receipt-item'>
                                <div><b>Total Amount:</b></div>&nbsp;
                                <div>{formatMoney(parseFloat(amount) + parseFloat(paymentMade?.serviceFeeAmount.toString()))}</div>
                            </div>
                            <div className='uvp-receipt-item'>
                                <div><b>Payment Status:</b></div>&nbsp;
                                <div>{paymentMade ? (paymentMade.error ? "Declined" : "Approved") : "Processing..."}</div>
                            </div>
                            <div className='uvp-receipt-item'>
                                <div><b>{paymentMade?.approvalCode ? "Confirmation Number" : "Details"}:</b></div>&nbsp;
                                <div>{paymentMade?.confirmationNumber ?? paymentMade?.error}</div>
                            </div>
                            <br/>
                            <p>Thank you for your business. We look forward to continuing to serve you.</p>
                            <p>
                                Regards, <br/>
                                {district.name}
                            </p>
                        </div>
                    </div>
                    <Grid container style={{ height: "465px" }}>
                        <Grid item xs={5} style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
                            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                <label className='uvp-label' style={{ marginTop: "20px" }}>
                                    <b>Account</b><span>&nbsp;:&nbsp;</span>
                                    <input className='uvp-input' style={{ width: "250px" }} type="text" defaultValue={billingAccount?.accountNumber} disabled={true} />
                                </label>
                            </div>
                            <div style={{ display: "flex" }}>
                                <label className='uvp-label' style={{ marginTop: "10px" }}>
                                    <b>Name</b><span>&nbsp;:&nbsp;</span>
                                    <input className='uvp-input' type="text" defaultValue={billingAccount?.customer.fullName} disabled={true} style={{ width: "250px" }} />
                                </label>
                            </div>
                            <div style={{ display: "flex" }}>
                                <label className='uvp-label' style={{ marginTop: "20px" }}>
                                    <b>Receipt Delivery Email</b><span>&nbsp;:&nbsp;</span>
                                    <input className='uvp-input' style={{ width: "250px" }} type="text" defaultValue={billingAccount?.customer?.email ?? newEmail} disabled={true} />
                                </label>
                            </div>
                            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                <label className='uvp-label' style={{ marginTop: "20px" }}>
                                    <b>Payment Method</b><span>&nbsp;:&nbsp;</span>
                                    <input className='uvp-input' style={{ width: "250px" }} type="text" value={paymentMade?.token ?
                                        `${paymentMade?.token?.tokenType === TokenType.CC ? paymentMade?.token?.cardType :
                                            `${paymentMade?.token?.achAccountHolderType} ${paymentMade?.token?.achType}`} ****${paymentMade?.token?.last4}` :
                                        paymentToken && paymentToken?.id !== "CCTerminal" ? `${paymentToken.tokenType === TokenType.CC ?
                                            paymentToken?.cardType : `${paymentToken?.achAccountHolderType} ${paymentToken?.achType}`} ****${paymentToken?.last4}` : "Terminal"} disabled={true} />
                                </label>
                            </div>
                            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                <label className='uvp-label' style={{ marginTop: "20px" }}>
                                    <b>Payment Date</b><span>&nbsp;:&nbsp;</span>
                                    <input className='uvp-input' style={{ width: "250px" }} type="text" value={paymentMade?.createdAt ? dateToLocal(paymentMade.createdAt).toLocaleDateString() : (new Date()).toLocaleDateString()} disabled={true} />
                                </label>
                            </div>
                            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                <label className='uvp-label' style={{ marginTop: "20px" }}>
                                    <b>Payment Amount</b><span>&nbsp;:&nbsp;</span>
                                    <input className='uvp-input' style={{ width: "250px" }} type="text" defaultValue={formatMoney(amount)} disabled={true} />
                                </label>
                            </div>
                            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                <label className='uvp-label' style={{ marginTop: "20px" }}>
                                    <b>Service Fee</b><span>&nbsp;:&nbsp;</span>
                                    <input className='uvp-input' style={{ width: "250px" }} type="text" defaultValue={formatMoney(paymentMade?.serviceFeeAmount)} disabled={true} />
                                </label>
                            </div>
                        </Grid>
                        <Grid item xs={6} style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
                            <div style={{ display: "flex", justifyContent: "flex-end", marginRight: "5px" }}>
                                <label className='uvp-label' style={{ marginTop: "20px" }}>
                                    <b>Total Amount</b><span>&nbsp;:&nbsp;</span>
                                    <input className='uvp-input' style={{ width: "250px" }} type="text" defaultValue={formatMoney(parseFloat(amount) + parseFloat(paymentMade?.serviceFeeAmount.toString()))} disabled={true} />
                                </label>
                            </div>
                            <div style={{ display: "flex", justifyContent: "flex-end", marginRight: "5px" }}>
                                <label className='uvp-label' style={{ marginTop: "20px" }}>
                                    <b>Payment Status</b><span>&nbsp;:&nbsp;</span>
                                    <input className='uvp-input' style={{ width: "250px" }} type="text" value={paymentMade ? (paymentMade.error ? "Declined" : "Approved") : "Processing..."} disabled={true} />
                                </label>
                            </div>
                            <div style={{ display: "flex", justifyContent: "flex-end", marginRight: "5px" }}>
                                <label className='uvp-label' style={{ marginTop: "20px" }}>
                                    <b>Confirmation Number</b><span>&nbsp;:&nbsp;</span>
                                    <input className='uvp-input' style={{ width: "250px" }} type="text" value={paymentMade?.confirmationNumber} disabled={true} />
                                </label>
                            </div>
                            <Grid container style={{ display: "flex", justifyContent: "flex-end", margin: "30px 0px 40px 0px" }}>
                                <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }}>
                                    {paymentMade && !paymentMade.error && (newPayment?.ach || newPayment?.cc) && paymentMade?.token?.id
                                        && (!tokenExists(paymentMade.token.id)) &&
                                        <>
                                            <label className='uvp-label'>
                                                <b>Save Payment Method?</b>
                                                <button onClick={() => saveMethod(true)} className={"green-button uvp-button"}
                                                    style={{
                                                        margin: "10px",
                                                        padding: "5px 10px",
                                                        width: "120px"
                                                    }}>
                                                    Yes
                                                </button>
                                                <button onClick={() => saveMethod(false)} className={"gray-button uvp-button"}
                                                    style={{
                                                        marginRight: "10px",
                                                        padding: "5px 10px",
                                                        width: "120px"
                                                    }}>
                                                    No
                                                </button>
                                            </label>
                                        </>
                                    }
                                </Grid>
                                {paymentMade &&
                                    <>
                                        <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }}>
                                            <button onClick={async () => await createPdf()} className={"green-button uvp-button"}
                                                style={{
                                                    margin: "10px",
                                                    padding: "5px 10px",
                                                    width: "120px"
                                                }}>
                                                Print Receipt
                                            </button>
                                            <button onClick={async () => cancel()} className={"gray-button uvp-button"}
                                                style={{
                                                    margin: "10px",
                                                    padding: "5px 10px",
                                                    width: "120px"
                                                }}>
                                                Close
                                            </button>
                                        </Grid>
                                        <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", marginTop: "10px" }}>
                                            <>
                                                {pdfDocSuccess &&
                                                    <div className='clickable' onClick={() => savePdf(pdfDoc)} style={{ color: "#5bc058", fontSize: "14px", marginRight: "5px" }}>
                                                        <u>PaymentTransactionReceipt.pdf</u>
                                                    </div>
                                                }
                                            </>
                                        </Grid>
                                    </>
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                </>
            }
            {loading &&
                <div className='loading-container'><CircularProgress color="primary" className='center-spinner' /></div>
            }
        </React.Fragment>
    )
}